export enum CampaignType {
  PRESCREEN = "prescreen",
  DIRECT = "direct",
}
